/**
 * Redefinição de senha pelo link que o barbeiro mandou no WhatsApp.
 *
 * Não há e-mail na v1: o cliente pede ao barbeiro, que gera o link em um toque
 * na ficha dele. Resolve o caso real — as duas pessoas se conhecem.
 */

import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, ErrorNote, Field } from '../components/ui.tsx';
import { ApiError, api } from '../lib/api.ts';

export function NewPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') ?? '';

  const [password, setPassword] = useState('');
  const [error, setError] = useState<ApiError | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await api.post('/auth/reset', { token, password });
      setDone(true);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught : null);
    } finally {
      setLoading(false);
    }
  }

  if (!token) {
    return (
      <div className="mx-auto flex min-h-full max-w-sm flex-col justify-center gap-4 px-6 text-center">
        <h1 className="text-[20px] font-bold text-ink">Link incompleto</h1>
        <p className="text-[15px] text-ink-soft">
          Abra o link exatamente como a barbearia enviou, ou peça um novo.
        </p>
      </div>
    );
  }

  if (done) {
    return (
      <div className="mx-auto flex min-h-full max-w-sm flex-col justify-center gap-4 px-6 text-center">
        <h1 className="text-[20px] font-bold text-ink">Senha alterada</h1>
        <p className="text-[15px] text-ink-soft">Agora é só entrar com a senha nova.</p>
        <Button full onClick={() => navigate('/entrar', { replace: true })}>
          Entrar
        </Button>
      </div>
    );
  }

  return (
    <div className="pb-safe mx-auto flex min-h-full w-full max-w-sm flex-col justify-center gap-6 px-6 py-10">
      <div className="text-center">
        <h1 className="text-[22px] font-bold text-ink">Nova senha</h1>
        <p className="pt-1 text-[14px] text-ink-soft">Escolha uma senha para a sua conta</p>
      </div>

      <form onSubmit={submit} className="flex flex-col gap-4">
        <Field
          label="Nova senha"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoComplete="new-password"
          error={error?.fieldError('password')}
          hint="No mínimo 8 caracteres"
          required
        />

        {error && !error.fieldError('password') && <ErrorNote>{error.message}</ErrorNote>}

        <Button type="submit" full loading={loading}>
          Salvar senha
        </Button>
      </form>
    </div>
  );
}
